import React from 'react';
import { faPhoneAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Contactform from './Contactform';

 export default function Contact() {
  return (
      <div className="contact" id="contact">
         <div className="container">
            <div className="row margin-row">
               <div className="col-md-12">
                  <div className="cntct-box">
                     <h2 className="heading">Get in Touch</h2>
                     <div className="row">
                        {/* <div className="col-lg-7 col-md-6">
                           <Contactform/>
                        </div> */}
                        <div className="col-md-6">
                           <ul>
                              <li>
                                 <FontAwesomeIcon icon={faPhoneAlt} />
                                 <a href="https://wa.link/9cel1i">+92 302 4353010</a>
                              </li>
                              <li>
                                 <FontAwesomeIcon icon={faEnvelope} />
                                 <a href="mailto:ramzan2015cs@gmail.com"> ramzan2015cs@gmail.com </a>
                              </li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
    )
}